import { TableCell, TableRow } from "@mui/material";
import React from "react";
import {
  tableCellEndStyles,
  tableCellAmtEndStyles,
  tableCellCenterStyles,
  tableCellStyles,
  dutyLabelStyles,
} from "./ExciseServTableBeerRowStyles";
export const renderExciseDutyRow = (
  label: string,
  amount: number,
  index: number,
  amountPerKeg: number
) => (
  <TableRow data-testid={`excise-duty-${label}-${index}`}>
    <TableCell aria-labelledby="service-description" sx={dutyLabelStyles}>
      {label}
    </TableCell>
    <TableCell
      aria-labelledby="unit-keg"
      colSpan={1}
      sx={{ borderBottom: "none" }}
    />
    <TableCell aria-labelledby="unit-keg" sx={tableCellCenterStyles}>
      {amountPerKeg}
    </TableCell>
    <TableCell
      aria-labelledby="unit-keg"
      colSpan={2}
      sx={{ borderBottom: "none" }}
    />
    <TableCell aria-labelledby="amount" sx={tableCellEndStyles}>
      {amount.toLocaleString()}
    </TableCell>
  </TableRow>
);

export const renderBeerRow = (beer: any, index: number) => {
  const subtotal = beer.amount + beer.exciseDuty + beer.additionalExciseDuty;
  return (
    <>
      <TableRow data-testid={`beer-row-${index}`}>
        <TableCell
          data-testid={`beer-name-${index}`}
          aria-labelledby="service-description"
          sx={{
            width: "50%",
            borderRight: "3px solid black",
            ...tableCellStyles,
          }}
        >
          {index + 1}. {beer.beerName}
        </TableCell>
        <TableCell
          data-testid={`unit-keg-${index}`}
          aria-labelledby="unit-keg"
          sx={tableCellCenterStyles}
        >
          {beer.unitKegL}
        </TableCell>
        <TableCell
          data-testid={`unit-rate-${index}`}
          aria-labelledby="unit-rate"
          sx={tableCellCenterStyles}
        >
          {beer.unitRatePerKeg.toLocaleString()}
        </TableCell>
        <TableCell
          data-testid={`keg-nos-${index}`}
          aria-labelledby="keg-nos"
          sx={tableCellCenterStyles}
        >
          {beer.kegNos}
        </TableCell>
        <TableCell
          data-testid={`litres-${index}`}
          aria-labelledby="litres"
          sx={tableCellCenterStyles}
        >
          {beer.litres}
        </TableCell>
        <TableCell
          data-testid={`amount-${index}`}
          aria-labelledby="amount"
          sx={tableCellAmtEndStyles}
        >
          {beer.amount.toLocaleString()}
        </TableCell>
      </TableRow>

      {renderExciseDutyRow(
        `Excise Duty @ Rs. ${beer.exciseDutyPerL} per Litre`,
        beer.exciseDuty,
        index,
        beer.edPerKeg
      )}
      {renderExciseDutyRow(
        "Additional Excise Duty @ 185% per Litre",
        beer.additionalExciseDuty,
        index,
        beer.aedPerKeg
      )}

      {/* Sub Total Row */}
      <TableRow>
        <TableCell
          aria-labelledby="service-description"
          sx={{
            width: "50%",
            borderRight: "3px solid black",
            textAlign: "end",
            borderTop: "3px solid black",
            borderBottom: "3px solid black",
            fontSize: "10px",
            lineHeight: 2,
            "&.MuiTableCell-root.MuiTableCell-root": {
              paddingRight: "5px",
              fontFamily: "Inter",
            },
          }}
        >
          Sub Total
        </TableCell>
        <TableCell
          aria-labelledby="unit-keg"
          colSpan={2}
          sx={{
            borderTop: "3px solid black",
            borderBottom: "3px solid black",
          }}
        />
        <TableCell
          aria-labelledby="keg-nos"
          sx={{
            textAlign: "center",
            borderTop: "3px solid black",
            borderBottom: "3px solid black",
            fontSize: "10px",
            "&.MuiTableCell-root.MuiTableCell-root": {
              fontFamily: "Inter",
            },
          }}
        >
          {beer.kegNos}
        </TableCell>
        <TableCell
          aria-labelledby="litres"
          sx={{
            textAlign: "center",
            borderTop: "3px solid black",
            borderBottom: "3px solid black",
            fontSize: "10px",
            "&.MuiTableCell-root.MuiTableCell-root": {
              fontFamily: "Inter",
            },
          }}
        >
          {beer.litres}
        </TableCell>
        <TableCell
          aria-labelledby="amount"
          sx={{
            textAlign: "end",
            borderTop: "3px solid black",
            borderBottom: "3px solid black",
            fontSize: "10px",
            "&.MuiTableCell-root.MuiTableCell-root": {
              paddingRight: "10px",
              fontFamily: "Inter",
            },
          }}
        >
          {subtotal.toLocaleString()}
        </TableCell>
      </TableRow>
    </>
  );
};
